export default __webpack_public_path__ + "static/media/project2.946179e8.jpg";